//* Importing necessary modules
import React from "react";

//* Importing common components
import { Link } from "react-router-dom";

//* Importing bootstrap components
import { Container } from "react-bootstrap";

//* Importing lucide icons
import { Lock } from "lucide-react";

//? Importing styles
import "./Unauthorized.css"; 

const Unauthorized: React.FC = () => {
  return (
    <Container fluid className="unauthorized-container">
      {/* Ícone do Lock com sombra */}
      <div className="unauthorized-icon">
        <Lock size={50} />
      </div>

      {/* Título */}
      <h1 className="unauthorized-title">Acesso Negado</h1>

      {/* Texto descritivo */}
      <p className="unauthorized-text">
        Parece que você não tem permissão para acessar esta página. <br />
        Verifique suas credenciais ou entre em contato com o suporte.
      </p>

      {/* Botão de voltar */}
      <Link to="/" className="unauthorized-button">
        Voltar para a Página Inicial
      </Link>
    </Container>
  );
};

export default Unauthorized;
